var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 120.254,
    height: 23.019,
    viewBox: "0 0 120.254 23.019",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_67",
    "data-name": "Group 67",
    transform: "translate(-362.945 -555.161)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_95",
    "data-name": "Path 95",
    d: "M365.251,587.753c0-1.165,1.045-1.714,2.382-1.714a4.866,4.866,0,0,1,2.6.754.189.189,0,0,0,.257-.051l.84-1.354a.181.181,0,0,0-.034-.24A5.73,5.73,0,0,0,367.633,584c-2.348,0-4.644,1.7-4.644,3.787,0,4.489,7.111,2.982,7.111,5.757,0,1.028-1.062,1.611-2.656,1.611a5.059,5.059,0,0,1-3.136-1.217.185.185,0,0,0-.257.017l-1.062,1.319a.186.186,0,0,0,.017.257,7.092,7.092,0,0,0,4.815,1.7c2.57,0,4.609-1.628,4.609-3.684C372.413,588.866,365.251,590.34,365.251,587.753Z",
    transform: "translate(0 -23.897)",
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_96",
    "data-name": "Path 96",
    d: "M657.474,585.8h-2.108a.13.13,0,0,0-.137.1l-3.444,9.493-4.112-9.493a.136.136,0,0,0-.137-.086h-2.142a.151.151,0,0,0-.137.206l5.415,12.046c-.5,2.159-1.559,3.478-2.707,3.478a3.118,3.118,0,0,1-1.594-.5.2.2,0,0,0-.274.086l-.651,1.371a.216.216,0,0,0,.034.223,3.455,3.455,0,0,0,2.313.84c3.6,0,5.106-5.5,5.106-5.5l4.678-12.046C657.646,585.9,657.577,585.8,657.474,585.8Z",
    transform: "translate(-233.93 -25.389)",
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_97",
    "data-name": "Path 97",
    d: "M797.92,584.226H796a.147.147,0,0,0-.137.137v1.714a6.085,6.085,0,0,0-4.626-2.176,6.607,6.607,0,0,0,0,13.194,6.058,6.058,0,0,0,4.626-2.176v1.714a.147.147,0,0,0,.137.137h1.919a.147.147,0,0,0,.137-.137V584.38C798.057,584.277,798.005,584.226,797.92,584.226Zm-6.374,10.829a4.565,4.565,0,1,1,4.318-4.558A4.444,4.444,0,0,1,791.546,595.055Z",
    transform: "translate(-349.736 -23.814)",
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_98",
    "data-name": "Path 98",
    d: "M883.62,560.583a6.059,6.059,0,0,0-4.626,2.176v-6.768a.222.222,0,0,0-.274-.223l-1.748.428a.222.222,0,0,0-.171.223v16.689a.307.307,0,0,0,.308.308h1.576a.307.307,0,0,0,.308-.308v-1.525a6.085,6.085,0,0,0,4.626,2.176,6.6,6.6,0,0,0,0-13.177Zm-.308,11.155a4.565,4.565,0,1,1,4.318-4.558A4.444,4.444,0,0,1,883.311,571.738Z",
    transform: "translate(-425.806 -0.497)",
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_99",
    "data-name": "Path 99",
    d: "M1003.877,588.612c-.069-.206-.154-.5-.223-.668a7.972,7.972,0,0,0-.377-.771l-.034-.086h-.017a6.379,6.379,0,0,0-5.5-3.187,6.6,6.6,0,0,0,0,13.194,6.752,6.752,0,0,0,5.86-3.187.212.212,0,0,0-.051-.257l-1.439-.925a.189.189,0,0,0-.257.051,5,5,0,0,1-4.1,2.262,4.188,4.188,0,0,1-3.307-1.662l9.287-4.4A.324.324,0,0,0,1003.877,588.612ZM993.6,591.645a5.014,5.014,0,0,1-.137-1.148,4.409,4.409,0,0,1,4.267-4.541,4.2,4.2,0,0,1,3.564,2.056Z",
    transform: "translate(-520.686 -23.814)",
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_100",
    "data-name": "Path 100",
    d: "M493.715,585.8H491.8a.147.147,0,0,0-.137.137v8.379a4.075,4.075,0,0,1-3.5,2.3h0a3.1,3.1,0,0,1-3.17-3v-7.608a.19.19,0,0,0-.188-.188h-1.816a.19.19,0,0,0-.189.188V593.7a4.948,4.948,0,0,0,4.883,4.986,5.474,5.474,0,0,0,3.975-1.8v1.336a.147.147,0,0,0,.137.137h1.919a.147.147,0,0,0,.137-.137V585.954A.14.14,0,0,0,493.715,585.8Z",
    transform: "translate(-99.318 -25.389)",
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_101",
    "data-name": "Path 101",
    d: "M428.287,580.025a.185.185,0,0,0-.257-.086,4.638,4.638,0,0,1-2.108.531c-1.714,0-1.731-1.868-1.731-1.868V571.56h4.027a.147.147,0,0,0,.137-.137v-1.679a.147.147,0,0,0-.137-.137h-4.027v-3.119A.19.19,0,0,0,424,566.3h-1.816a.19.19,0,0,0-.189.188v3.119h-2.262a.147.147,0,0,0-.137.137v1.679a.147.147,0,0,0,.137.137H422V578.6a3.561,3.561,0,0,0,3.753,3.872,6.213,6.213,0,0,0,3.119-.977.19.19,0,0,0,.069-.24Z",
    transform: "translate(-46.947 -9.23)",
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_102",
    "data-name": "Path 102",
    d: "M733.587,580.025a.185.185,0,0,0-.257-.086,4.638,4.638,0,0,1-2.108.531c-1.714,0-1.731-1.868-1.731-1.868V571.56h4.027a.147.147,0,0,0,.137-.137v-1.679a.147.147,0,0,0-.137-.137h-4.027v-3.119a.19.19,0,0,0-.188-.188h-1.816a.19.19,0,0,0-.188.188v3.119h-2.262a.147.147,0,0,0-.137.137v1.662a.135.135,0,0,0,.137.137H727.3v7.042a3.561,3.561,0,0,0,3.753,3.872,6.213,6.213,0,0,0,3.119-.977.19.19,0,0,0,.069-.24Z",
    transform: "translate(-299.934 -9.23)",
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_103",
    "data-name": "Path 103",
    d: "M572.783,555.768l-1.748.428a.222.222,0,0,0-.171.223v6.34a6.086,6.086,0,0,0-4.626-2.176,6.607,6.607,0,0,0,0,13.194,6.086,6.086,0,0,0,4.626-2.176v1.525a.307.307,0,0,0,.308.308h1.576a.307.307,0,0,0,.308-.308V555.991A.222.222,0,0,0,572.783,555.768Zm-1.919,11.48a4.565,4.565,0,1,1,0-.137Z",
    transform: "translate(-163.289 -0.497)",
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_104",
    "data-name": "Path 104",
    d: "M967.619,555.168l-1.748.428a.222.222,0,0,0-.171.223v16.792a.307.307,0,0,0,.308.308h1.576a.307.307,0,0,0,.308-.308V555.391A.211.211,0,0,0,967.619,555.168Z",
    transform: "translate(-499.473)",
    fill: "#ffffff"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/Logo.82fab060b7523952b74991a78e440b98.svg";
export { ForwardRef as ReactComponent };